import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import PopUp from '../../../../../Shared/Popup/PopUp';
import BtnSubmit from "../../../../../Shared/Buttons/BtnSubmit";

const OrderErrorPopUp = (props) => {

  return (
    <PopUp showPopUp={props.showPopUp} onClose={() => props.closePopUp()} className='cellular-order-error-popup'>
      <Image src={require('./images/error.svg')} alt='' />
      <h1>לא הצלחנו לשייך לך את החבילה שבחרת <br/> נציג שלנו יחזור אלייך ממש בקרוב</h1>
      <p>הנציג שלנו יפנה אליך בקרוב כדי לסיים את הרכישה של הקווים הבאים</p>
      {props.phoneNumbers?.map((item , index) => {
        return (<div key={index} className='phone-number'>קו {index + 1} | {item}</div>)
      })}
      <BtnSubmit
          isBusiness={false}
          text={props.btnText}
          onclick={() => props.onClickBtn()}
          formid={'order-error-form'}
          isDisplayArrows={false}
      />
    </PopUp>
  );
};

export default OrderErrorPopUp;
